import { createBrowserRouter } from 'react-router-dom';
import { Root } from '@/App';
import { Error } from './Error';
import { Layout } from '@/components/Layout';
import { SignIn } from '@/modules/SignIn';
import { ProtectedRoute } from './ProtectedRoute';

// modules
import AuditoriaModule from '@/modules/Auditoria';
import ConfiguracaoModule from '@/modules/Configuracao';
import EntradasModule from '@/modules/Entradas';
import ExpedicoesModule from '@/modules/Expedicoes';
import PainelModule from '@/modules/Painel';
import MovimentacoesModule from '@/modules/Movimentacoes';
import LogoutModule from '@/modules/Logout'
import { ModuleFakeErp } from '@/modules/FakeRp';
import ModuleRelatorio from '@/modules/Relatorio';
import ModuleAtualizacao from '@/modules/Atualizacoes';
import ModuleAbastecimento from '@/modules/Abastecimento';
import ModulePortaria from '@/modules/Portaria';
import ModuleAcompanhamentoPortaria from '@/modules/AcompanhamentoPortaria';

import { Page404 } from './Error/404';


export const router = createBrowserRouter([
  {
    path: '/',
    errorElement: <Error />,
    element: <Root />,
    children: [
      {
        path: '',
        element: (
          <ProtectedRoute>
            <Layout />
          </ProtectedRoute>
        ),
        children: [
          ...PainelModule.routes,
          ...AuditoriaModule.routes,
          ...ConfiguracaoModule.routes,
          ...EntradasModule.routes,
          ...ExpedicoesModule.routes,
          ...MovimentacoesModule.routes,
          ...LogoutModule.routes,
          ...ModuleFakeErp.routes,
          ...ModuleAtualizacao.routes,
          ...ModuleAbastecimento.routes,
          ...ModulePortaria.routes,
          ...ModuleAcompanhamentoPortaria.routes,
          ...ModuleRelatorio.routes
        ],
      },
      {
        path: 'signin',
        element: <SignIn />,
      },
    ],
  },
  {
    path: '*',
    element: <Page404/> 
    }
]);
